export interface IAvatar {
  releaseStatus?: string;
  age?: number;
  avatarStatus: string | null;
  customAvatar: boolean;
  gender: 'male' | 'female' | 'other';
  id: string;
  inputImageUrl?: string;
  menuCircleImageUrl: string | null;
  menuImageUrl?: string | null;
  rawImageUrl?: string | null;
  name: string;
  publicAvatar: boolean;
  talkingPhoto: boolean;
  talkingPhotoUpperBody?: boolean;
  idleLoopVideoUrl?: string;
  hasIdleLoop?: boolean;
  isUploaded?: boolean;
  photorealistic: boolean;
  models: string[];
  selectedModelIndex?: number;
}

export interface IVoice {
  audioSampleUrl: string | null;
  gender: 'male' | 'female';
  id: string;
  isNeural: boolean;
  language: string;
  languageCode: string;
  languageCodes: string[];
  languageCodesJson: string;
  name: string;
  provider: string;
  textToSpeechApiProvider: string;
  voiceId: string;
  maxCharacterLimit: number | string;
  isPremiumVoice?: boolean;
  isMultilingual: boolean;
}

export type VoicePreviewPayload = {
  voiceId: string;
  script: string;
  soundTemplate: string;
  speechVolume: number;
  speechSpeed: number;
  estimate: boolean;
};

export type VideoGenerationPayload = {
  draft: boolean;
  avatarId: string | null;
  fullFrame: boolean;
  voiceId?: string | null;
  voiceoverId?: string | null;
  voiceOverUrl?: string | null;
  script: string;
  videoFormat: string;
  videoWidth: number;
  videoHeight: number;
  videoTitle: string;
  dynamic: boolean;
  parentId?: string;
  model: string;
};

export type Country = {
  name: string;
  emoji?: string;
  unicode?: string;
  image?: string;
};

export type Language = {
  name: string;
  country: Country | null;
};

export type VoiceFilter = {
  language: Language;
  provider: string[];
};

export type Voiceover = {
  id: string;
  name: string;
  link: string;
  size?: number;
  audio: HTMLAudioElement;
};

export type GenderOptions = 'male' | 'female' | 'other';
export type AvatarOptions = 'stock' | 'my avatars';
export type FormatOptions = 1.77777777778 | 0.5625 | 1 | 0.8;
export type FormatLabels = '16:9' | '9:16' | '1:1' | '4:5';
export type StyleOptions = 'friendly' | 'professional' | 'cheeky' | 'happy';

export type UploadedPhotoFileData = {
  name: string;
  size: string;
  data?: any | null;
};

export type UploadedPhotoDetails = {
  inputImageUrl: string;
  gender: 'Male' | 'Female' | 'Other' | null;
  name: string;
  age: number | null;
};

export type GetCreditsResponse = {
  creditsAmount: string;
  creditsMax: string;
};

export type JoinWaitlistRequest = {
  email: string;
  feature_request: string;
  feature_request_details: string;
};

export interface IUser {
  id: string;
  email: string;
  first_name: string;
  company_name: string | null;
  // TODO: wait the field from backend
  country: string | null;
  apiKey: string;
}

export interface IPlan {
  id: string;
  credits: number;
  externalId: string;
  externalType: string;
  isActive: boolean;
  nextRenewalDate: null | Date;
  price: number;
  productName: string;
  renewalType: 'NonRecurring' | 'Monthly' | 'Annually';
  paymentLink: string;
}

export interface IMessage {
  id: string;
  role: 'user' | 'assistant';
  content: string;
  hidden: boolean;
}

export interface SavedVideoProject {
  avatarId: string;
  voiceId: string | null;
  voiceOverUrl: string | null;
  voiceOverName: string | null;
  script: string;
  videoTitle: string | null;
  parentId: string;
  voiceoverId: string | null;
}

export interface ICreditCalculatorPayload {
  resource: '/TalkingPhotos' | '/Videos' | '/Speech';
  httpVerb: 'POST';
  provider: string | null;
  script: string | null;
  durationInSeconds: number | null;
}

export enum TalkingPhotosModal {
  FIRST_MODEL = 'v3.1',
  SECOND_MODEL = 'v2.1'
}
